import { inject, InjectionToken, Provider, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { UserFeedbackRequest, UserPrompt } from '@panaya/ai-chat/shared';

interface AiEventNotifier {
    launch: Observable<void>;
    initThreadRequest: Observable<void>;
    restoreThreadRequest: Observable<string>;
    closeThreadRequest: Observable<void>;
    promptRequest: Observable<UserPrompt>;
    userFeedbackRequest: Observable<UserFeedbackRequest>;
    interruptRequest: Observable<void>;
}

const AI_EVENT_NOTIFIER = new InjectionToken<AiEventNotifier>('AI Event Notifier');

/**
 * Connects an existing AI related events service with the conversation API.
 * Should be provided at app-level.
 *
 * @param {Type<AiEventNotifier>} notifier An existing service which is connected to the UI and
 * triggeres events to manage the conversation API.
 */
export function provideAiChatEventNotifier(notifier: Type<AiEventNotifier>): Provider {
    return { provide: AI_EVENT_NOTIFIER, useExisting: notifier };
}

/**
 * Injects the service that represents UI events related with the AI conversaion.
 */
export function injectAiChatEventNotifier(): AiEventNotifier {
    return inject(AI_EVENT_NOTIFIER);
}
